(function () {
  const dialog = document.getElementById('compound-concern-popup');
  const content = document.getElementById('compound-concern-popup-content');
  const closeBtn = document.querySelector('[data-popup-close]');
  const cards = document.querySelectorAll('[data-concern-card]');

  if (!dialog || !content) return;

  function openPopup(handle) {
    const template = document.getElementById('compound-popup-' + handle);
    if (!template || !template.content) return;
    content.innerHTML = '';
    content.appendChild(template.content.cloneNode(true));
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    dialog.close();
    document.body.style.overflow = '';
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      e.preventDefault();
      const handle = card.getAttribute('data-concern-handle');
      if (handle) openPopup(handle);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closePopup();
  });

  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

  // Smooth scroll logic for filter links
  const scrollLinks = document.querySelectorAll('[data-scroll-link]');
  scrollLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetEl = document.querySelector(targetId);

      if (targetEl) {
        const headerHeight = document.body.style.getPropertyValue('--header-height') || '0px';
        const headerPixels = parseInt(headerHeight) || 0;
        const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = targetPosition - headerPixels - 40; // 40px extra breathing room

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
})();
